import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from '@/icons';
import './help-tour.css';

interface WelcomeBannerProps {
  name: string;
  onStart: () => void;
  onDismiss: () => void;
}

const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ name, onStart, onDismiss }) => (
  <div className="welcome-banner">
    <span className="welcome-banner__stripe" aria-hidden />
    <div className="welcome-banner__body">
      <p className="welcome-banner__title">Welcome to WeTree, {name}.</p>
      <p className="welcome-banner__sub">
        Take a quick tour and we&apos;ll show you how to pick and manage your family trees.
      </p>
    </div>
    <WelcomeBannerActions onDismiss={onDismiss} onStart={onStart} />
  </div>
);

function WelcomeBannerActions({ onDismiss, onStart }: { onDismiss: () => void; onStart: () => void }) {
  const { t } = useTranslation('forms');
  return (
    <div className="welcome-banner__actions">
      <button type="button" className="btn btn--ghost btn--sm" onClick={onDismiss}>
        {t('actions.maybeLater')}
      </button>
      <button type="button" className="btn btn--primary btn--sm" onClick={onStart}>
        <Sparkles width={13} height={13} />
        {t('actions.startTour')}
      </button>
    </div>
  );
}

export default WelcomeBanner;
